import React from "react";
import { Loader2 } from "lucide-react";

const NAMES = { gpay: "Google Pay", phonepe: "PhonePe", paytm: "Paytm", any: "your UPI app" };

export const UpiIntentOverlay = ({ app, onCancel, onOtherOptions }) => (
  <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-slate-900/50 px-4 pb-6" data-testid="upi-intent-overlay">
    <div className="w-full max-w-sm bg-white rounded-3xl p-6 shadow-2xl text-center">
      <Loader2 className="mx-auto animate-spin text-blue-500" size={36} />
      <p className="mt-4 text-slate-900 font-semibold text-lg" data-testid="upi-intent-overlay-title">
        Complete the payment in {NAMES[app] || "your UPI app"}
      </p>
      <p className="mt-1 text-slate-500 text-sm">Enter your UPI PIN there, then come back here. Don't close this page.</p>
      <button
        onClick={onOtherOptions}
        className="mt-5 w-full bg-[#F0D65B] hover:bg-[#E5C947] text-slate-900 font-semibold py-3 rounded-2xl transition-colors"
        data-testid="upi-intent-other-options-btn"
      >
        App didn't open? Use other payment options
      </button>
      <button
        onClick={onCancel}
        className="mt-2 w-full text-slate-500 hover:text-slate-700 text-sm font-medium py-2 transition-colors"
        data-testid="upi-intent-cancel-btn"
      >
        Cancel payment
      </button>
    </div>
  </div>
);
